/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationBatchStatusGridItemViewModel } from "../types/CourseRegistrationBatchStatusGridItemViewModel.ts";
import { eScholarshipStatusSchema } from "./eScholarshipStatusSchema.ts";

export const courseRegistrationBatchStatusGridItemViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula."),
  ),
  personId: z.optional(
    z.number().int().describe("ID da pessoa (aluno) associada à matrícula."),
  ),
  personName: z.string().describe("Nome completo do aluno.").nullish(),
  oldStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status de matrícula atual (origem) do aluno, elegível para transição para o status destino solicitado. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
      ),
  ),
  date: z
    .string()
    .datetime()
    .describe("Data de criação da matrícula. Opcional.")
    .nullish(),
  scholarshipStatus: z.optional(
    z
      .lazy(() => eScholarshipStatusSchema)
      .describe(
        "1 = Interested | 2 = InProcess | 3 = ScholarshipHolder | 4 = Refused | 5 = RefusedInterested | 6 = RefusedPotential | ",
      ),
  ),
  scholarshipStatusDescription: z
    .string()
    .describe(
      "Descrição textual do status de bolsa. Vazio quando não há bolsa.",
    )
    .nullish(),
  isChecked: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o aluno está selecionado para a alteração de status em lote. Sempre retornado como false pela API.",
      ),
  ),
  studentsNumber: z.optional(
    z
      .number()
      .int()
      .describe(
        "Total de alunos elegíveis retornados pela consulta (antes da paginação).",
      ),
  ),
  avgGrade: z.optional(
    z.number().describe("Média das notas de disciplinas do aluno na turma."),
  ),
  avgAttendance: z.optional(
    z
      .number()
      .describe(
        "Média de frequência do aluno nas disciplinas da turma, em percentual.",
      ),
  ),
  finalExamGrade: z.optional(
    z.number().describe("Nota do exame final do aluno na turma."),
  ),
  monographDefGrade: z.optional(
    z.number().describe("Nota da defesa de monografia do aluno na turma."),
  ),
}) as unknown as ToZod<CourseRegistrationBatchStatusGridItemViewModel>;
